export default "__VITE_ASSET__co_DdF2G__"